import { graphql, useStaticQuery } from 'gatsby';

export const siteConfigFragment = graphql`
	fragment SiteConfigFragment on ContentfulSiteConfig {
		title
		headerLogo {
			title
			url
		}
		footerLogo {
			title
			url
		}
		sidebarLogo {
			title
			url
		}
		navigationBarLinks {
			title
			slug
		}
		navigationMapLinksCompany {
			title
			slug
		}
		navigationMapLinksLegal {
			title
			slug
		}
		navigationMapLinksSocials {
			title
			slug
			image {
				title
				url
				publicUrl
			}
		}
		sidebarLinks {
			title
			slug
			image {
				title
				url
			}
		}
		footerCopyrightText
		newsletterHeroTitle
		newsletterHeroSummary
		newsletterHeroCallToActionTitle
		newsletterHeroTitleSubmitted
		newsletterHeroSummarySubmitted
		newsletterHeroCallToActionTitleError
		newsletterHeroImage {
			title
			gatsbyImageData
		}
		contactUsHeroTitle
		contactUsHeroCallToActionTitle
		contactUsHeroImage {
			title
			gatsbyImageData
		}
		supportEmail
		formErrorMessage
	}
`;

export const useSiteConfig = () => {
	const data = useStaticQuery<Queries.SiteConfigQuery>(graphql`
		query SiteConfig {
			siteConfigs: allContentfulSiteConfig(limit: 1) {
				nodes {
					...SiteConfigFragment
				}
			}
		}
	`);

	return data?.siteConfigs?.nodes?.[0];
};
